import React from "react";
import io from "socket.io-client";
import {
  changeStatusSocket,
  setSocket,
  changeIdLogout,
  disconnectSocket,
  reconnectSocket,
} from "./redux/actions/socket.action";
import { connect } from "react-redux";

class Socket extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.count = 0;
  }

  componentDidMount() {
    this.initSocket();
  }

  componentWillUnmount() {
    this.socket.disconnect();
  }

  initSocket() {
    //  this.socket = io("https://sxd.sgmcvietnam.vn/", {
     this.socket = io("http://10.17.20.52/", {
      transports: ["websocket"],
      path: "mysocket",
    });
    this.socket.on("connect", () => {
      let token = localStorage.loginSession;
      this.socket.emit(
        "authenticate",
        {
          accessToken: `${token}`,
        },
        (data) => {}
      );
    });
    this.socket.on("logoutUser", (data) => {
      this.props.changeStatusSocket(true);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.id !== undefined) {
      this.logout(this.props.id);
      this.props.changeIdLogout(undefined);
    }

    if (this.props.isDisconnect) {
      this.socket.disconnect();
      this.count += 1;
      this.props.disconnectSocket(false);
    }

    if (this.props.isReconnect) {
      this.props.reconnectSocket(false);
      this.socket.disconnect();
      this.initSocket();
    }
  }

  logout(id) {
    this.socket.emit("onLogoutUser", { Id: id }, (data) => {});
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    isSocket: state.socket.isSocket,
    id: state.socket.id,
    isDisconnect: state.socket.isDisconnect,
    isReconnect: state.socket.isReconnect,
  };
};

const mapDispatchToProps = {
  changeStatusSocket: changeStatusSocket,
  setSocket: setSocket,
  changeIdLogout: changeIdLogout,
  disconnectSocket: disconnectSocket,
  reconnectSocket: reconnectSocket,
};

export default connect(mapStateToProps, mapDispatchToProps)(Socket);
